export default "__VITE_ASSET__CyzyEA8A__"